import React from 'react'
import { MarketoBannerForm } from 'newComponents'
import './styles.scss'

const successText = {
  title: 'Thanks for signing up!',
  subtitle: "We'll keep you posted on Trajectory 2021."
}

const CtaBanner = ({ text, marketoFormId }) => (
  <section className="section banner-signup">
    <div className="container banner-container">
      <div className="banner-title-container">
        <h3 className="banner-title">{text}</h3>
      </div>
      <div className="signup-form">
        <MarketoBannerForm formId={marketoFormId} successText={successText} />
      </div>
    </div>
  </section>
)
export default CtaBanner
